// extracted by mini-css-extract-plugin
export default {"banner":"banners_banner__zK+nu","bannerVideo":"banners_bannerVideo__qR1WW"};